module.exports = __webpack_public_path__ + "static/media/ParentingFamily.34c900e6.svg";